import _ from 'lodash';

export default {
  methods: {
    generateDrugName(drug) {
      let drugName;
      let isFpDrug = false;
      let drug2Id;
      let drug2Options;
      let adminRouteCode;
      let adminRoutes;
      let administrationRouteDescription;
      let diluentId;
      let diluents;
      let infusionTime;
      let containerId;
      let containerDescriptions;
      let containerTypeName;
      // let drug1Dose
      // let drug1DoseUom
      let containerTypes;
      let containerTypeId;
      let ancillary1Id;
      let ancillary2Id;
      let ancillaries;

      if (drug) {
        isFpDrug = drug.order_line_type !== 'PS' && drug.order_line_type !== 'PHARMACYPS';

        if (isFpDrug) {
          drugName = drug.description ? drug.description : drug.drug1Name;
        } else {
          drugName = (drug.drug1Label ? drug.drug1Label : drug.drug1Name);
        }

        drug2Id = drug.drug2ID;
        if (drug2Id) {
          drugName = drugName + ' & ' + (drug.drug2Label ? drug.drug2Label : drug.drug2Name);
        }
        drug2Options = false;
        adminRouteCode = drug.administrationRouteCode;
        adminRoutes = ['temp'];
        administrationRouteDescription = drug.administrationRouteDescription;
        diluentId = drug.diluentID;
        diluents = ['temp'];
        infusionTime = drug.infusionTime;
        containerId = false;
        containerTypeName = drug.containerTypeName ? drug.containerTypeName : drug.container;
        // drug1Dose = drug.drug1Dose
        // drug1DoseUom = drug.drug1DoseUom
        containerDescriptions = ['temp'];
        containerTypes = ['temp'];
        containerTypeId = drug.containerTypeId;
        ancillaries = ['temp'];
        ancillary1Id = drug.ancillary1ID ? drug.ancillary1ID : drug.ancillary1Id;
        ancillary2Id = drug.ancillary2ID ? drug.ancillary2ID : drug.ancillary2Id;
      } else {
        drugName = this.drugOne.label ? this.drugOne.label : this.drugOne.title;
        // drug1Dose = this.drug1_dose
        // drug1DoseUom = this.drug1_dose_uom
        isFpDrug = this.addingFpDrug;
        drug2Id = this.drug2_id;
        drug2Options = this.drug2Options;
        adminRouteCode = this.adminRouteCode;
        adminRoutes = this.adminRoutes;
        administrationRouteDescription = false;
        diluentId = this.diluent_id;
        diluents = this.diluents;
        infusionTime = this.infusionTime;
        containerId = this.containerId;
        containerTypeName = false;
        containerDescriptions = this.containerDescriptions;
        containerTypes = this.containerTypes;
        containerTypeId = this.containerTypeId;
        ancillaries = this.ancillaries;
        ancillary1Id = this.ancillary1Id;
        ancillary2Id = this.ancillary2Id;
      }


      // Hospital stock is different to regular stock
      // while (drugName.charAt(0) === '*') {
      //   drugName = drugName.substring(1);
      // }

      // if (drug1Dose && drug1DoseUom) {
      //   drugName = `${drugName} / ${drug1Dose}${drug1DoseUom}`;
      // }

      if (!isFpDrug) {
        if (drug2Id && drug2Options) {
          drugName = `${drugName} & ${drug2Options[drug2Id]}`;
        }

        if (administrationRouteDescription) {
          drugName = `${drugName} / ${administrationRouteDescription}`;
        } else {
          drugName = `${drugName} / ${adminRoutes[adminRouteCode]}`;
        }

        if (diluentId) {
          if (diluents[diluentId]) {
            drugName = `${drugName} / ${diluents[diluentId]}`;
          }
        }

        if (infusionTime) {
          drugName = `${drugName} / ${this.rounddec_2(infusionTime)} hr`;
        }

        if (containerId) {
          if (containerDescriptions[containerId]) {
            drugName = `${drugName} / ${containerDescriptions[containerId].genericName}`;

            switch (containerTypes[containerTypeId]) {
              case 'Syringe':
              case 'EmptyBag':
              case 'Empty Bag':
              case 'Reservoir':
              case 'Infusor':
                break;
              default:
                drugName = `${drugName} (${containerDescriptions[containerId].size})`;
                break;
            }
          }
        }
      }

      if (containerTypeName) {
        drugName = `${drugName} / ${containerTypeName}`;
      }


      if (!isFpDrug) {
        if (ancillary1Id && ancillary1Id !== '0') {
          if (drug && 'ancillary1Name' in drug) {
            drugName = `${drugName} / ${drug.ancillary1Name}`;
          } else {
            const ancillary1 = this.findAncilliary(ancillaries, ancillary1Id);
            if (ancillary1) {
              drugName = `${drugName} / ${ancillary1.genericName}`;
            }
          }
        }

        if (ancillary2Id && ancillary2Id !== '0') {
          if (drug && 'ancillary2Name' in drug) {
            drugName = `${drugName} / ${drug.ancillary2Name}`;
          } else {
            const ancillary2 = this.findAncilliary(ancillaries, ancillary2Id);
            if (ancillary2) {
              drugName = `${drugName} / ${ancillary2.genericName}`;
            }
          }
        }
      } else {
        if (ancillary1Id && ancillary1Id !== '0') {
          drugName = `${drugName} / ${ancillary1Id}`;
        }

        if (ancillary2Id && ancillary2Id !== '0') {
          drugName = `${drugName} / ${ancillary2Id}`;
        }
      }
      return drugName;
    },
    findAncilliary(ancillaries, ancillaryId) {
      let foundAncillary = _.find(ancillaries, (ancillary) => ancillary.componentID === (ancillaryId).toString());
      if (!foundAncillary) {
        foundAncillary = _.find(ancillaries, (ancillary) => ancillary.componentID === Number(ancillaryId));
      }
      return (foundAncillary);
    },
    rounddec_2(value) {
      if (!value) return value;
      return 0 + parseFloat(parseFloat(value).toFixed(2));
    },
  },
};
